export default {
  name: 'VideoHive',
  abbreviation: 'VH',
  domain: 'videohive.net',
  google_analytics_id: 'UA-11834194-8',
  google_remarketing_label: 'NrSdCMX_uQMQp-WC_AM',
  item_results_layout: 'grid',
  home_search_placeholder: 'e.g. photo slideshow',
  assets_domains: {
    item_thumbnail: 'thumb-vh.s3.envato.com',
    item_image: 'image-vh.s3.envato.com'
  },
  features: {
    /**
     * @description
     * @author Geoff Evason
     * @expires
     */
    'collapse-tags-unless-bottom-category': true,
    /**
     * @description Enable cookiebot
     * @author Luke Robins
     * @expires
     */
    cookiebot: true,
    /**
     * @description default sort order
     * @author Marek Wojtaszek
     * @expires when default sort experiment finishes
     */
    'defaultSort:enrolment': true,
    'experiments:loading-cover': true,
    'smart-header': true
  },
  ui: {
    featured_hero_item_viewtype: 'grid',
    item_list_views: [
      {
        value: 'grid',
        label: 'Grid'
      }
    ]
  }
}
